import { render, staticRenderFns } from "./LastCardTransaction.vue?vue&type=template&id=1a7135b5&"
import script from "./LastCardTransaction.vue?vue&type=script&lang=js&"
export * from "./LastCardTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports